import { render, staticRenderFns } from "./submitList.vue?vue&type=template&id=02dd3929&scoped=true&"
import script from "./submitList.vue?vue&type=script&lang=js&"
export * from "./submitList.vue?vue&type=script&lang=js&"
import style0 from "./submitList.vue?vue&type=style&index=0&id=02dd3929&prod&lang=scss&scoped=true&"
import style1 from "./submitList.vue?vue&type=style&index=1&id=02dd3929&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd3929",
  null
  
)

export default component.exports